<div class="c-themeToggle">
  <span><ng-content></ng-content></span>
  <mat-slide-toggle
    color="primary"
    (toggleChange)="switchTheme()"
    [checked]="darkModeEnabled$ | async">
  </mat-slide-toggle>
</div>
